import { useEffect } from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import GrainOverlay from "../components/GrainOverlay";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found | GoneSoon";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="not-found-page" className="relative">
      <GrainOverlay />
      <div className="bg-cream">
        <Nav variant="cream" />
      </div>

      <section className="bg-cream text-ink">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 py-24 md:py-40 text-center">
          <div className="pill text-ink/70 border-ink/20 mb-10 mx-auto w-fit">
            <span className="pill-dot" />
            404
          </div>
          <h1 data-testid="not-found-headline" className="h-display text-[3rem] md:text-[6rem] leading-[0.95]">
            Gone. <span className="text-coral">Already.</span>
          </h1>
          <p className="mt-8 text-lg md:text-xl text-ink/70 max-w-md mx-auto leading-relaxed">
            This page has claimed its final drop. Let's get you back to something that's still here.
          </p>
          <Link to="/" data-testid="not-found-home-link" className="btn-primary mt-12 inline-flex">
            Back to home
            <span aria-hidden="true">→</span>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
